import { ActionTree } from 'vuex'
import axios from 'axios'
import _get from 'lodash/get'

import { BASE_URL } from '@/config'
import { SellersState } from './types'
import { RootState } from '../types'
import { Seller, OfferItem } from '@/types'

export const actions: ActionTree<SellersState, RootState> = {
  getSellers({ commit }, payload) {
    const path = `${BASE_URL}/sellers`
    const params = {
      buyerUserId: payload.buyerUserId,
      limit: payload.limit || 20,
      offset: payload.offset || 0,
      order: payload.order || [],
      filter: payload.filter || {},
      keyword: payload.keyword || '',
    }

    return axios
      .get(path, { params })
      .then(response => {
        const data = _get(response, 'data') || []
        return data
      })
      .catch(err => {
        throw err
      })
  },
  postSeller({ commit, getters }, payload: Seller): any {
    const path = `${BASE_URL}/sellers`
    return axios
      .post(path, payload)
      .then(response => {
        const data = _get(response, 'data') || null
        return data
      })
      .catch(err => {
        throw err
      })
  },
  putSeller({ commit, getters }, payload: { id: string; data: Seller }): any {
    const path = `${BASE_URL}/sellers`
    return axios
      .put(path, { id: payload.id, data: payload.data })
      .then(response => {
        const data = _get(response, 'data') || null
        return data
      })
      .catch(err => {
        throw err
      })
  },
}
